import { Sort } from 'matrix';
import { SortType } from 'constants/enums/search';
import { SearchEventResult } from 'searchEvent';
import searchCategoryType from 'services/searchCategoryType/searchClient';
import { browserLogger } from 'utils/logger/browserLogger';

export async function getTrendingEvents(
  limit = 16
): Promise<SearchEventResult> {
  const searchParamsObject = {
    has_banner: '1',
    page: 0,
    need_pay: '1',
    is_free: '0',
    ongoing: '0',
    limit,
    sort: SortType.DAY_TRENDING_SCORE as Sort,
    service: '/v4/search/query',
    location_score: SortType.DAY_TRENDING_SCORE,
    type: 'normal'
  };

  try {
    return await searchCategoryType(searchParamsObject);
  } catch (error) {
    browserLogger().error({
      message: 'Não foi possível buscar os eventos em alta',
      data: String(error)
    });
    throw error;
  }
}
